export default class Dev {
  constructor(Vue) {
    this.portal = Vue.prototype.$portal;
    this.company = Vue.prototype.$company;
    Vue.prototype.$brain.dev = this;
    this.init();
  }

  init() {
    [this.domain] = window.location.href
      .replace('http://www.', '')
      .replace('https://www.', '')
      .replace('http://', '')
      .replace('https://', '')
      .replace(':8085', '')
      .replace(':8081', '')
      .replace(':80', '')
      .replace(':7171', '')
      .split('/');
    this.is = '';
  }

  check() {
    return new Promise((resolve, reject) => {
      /*
        IDENTIFICA QUAL AMBIENTE O SISTEMA ESTÁ SENDO INICIADO, ACIONANDO SUA
        RESPECTIVA FUNÇÃO DE INICIALIZAÇÃO.
      */
      if (this.domain.indexOf('localhost') >= 0)
        return this.initDev(() => resolve());
      this.initProduction(() => resolve());
    });
  }

  /*
    FUNÇÃO DE START PARA O SISTEMA EM DESENVOLVIMENTO
  */
  initDev(cb) {
    /* CONFIGURA O CAMINHO DO SERVERLESS PARA LOCAL */
    this.portal.url.endPoint.core = 'http://localhost:3042';
    this.portal.url.endPoint.app = 'http://localhost:3010/app';
    this.portal.url.endPoint.auth = 'http://localhost:3011/api/auth';
    this.portal.url.endPoint.access = 'http://localhost:3012/api/access';
    this.portal.url.endPoint.activity = 'http://localhost:3013/activity';
    this.portal.url.endPoint.remoteSql = 'http://localhost:3015/remotesql';
    this.portal.url.endPoint.admin = 'http://localhost:3016/pro-admin';
    this.portal.url.endPoint.file = 'http://localhost:3017/file';
    this.portal.url.endPoint.amcLicenciado =
      'http://localhost:3018/amc-licenciado';
    this.portal.url.endPoint.dfe = 'http://localhost:3019/dfe';
    this.portal.url.endPoint.paymentReminder =
      'http://localhost:3020/payment-reminder';
    this.portal.url.endPoint.amcPlm = 'http://localhost:3021/amc-plm';
    this.portal.url.endPoint.marketing = 'http://localhost:3022/marketing';
    this.portal.url.endPoint.faccionista = 'http://localhost:3023/faccionista';
    this.portal.url.endPoint.devolution = 'http://localhost:3024/devolution';
    this.portal.url.endPoint.bankbill = 'http://localhost:3026/bankbill';
    this.portal.url.endPoint.bankbill_partners =
      'http://localhost:3043/api/bankbill-partners';
    this.portal.url.endPoint.amcRepresentante =
      'http://localhost:3028/amc-representante';
    this.portal.url.endPoint.shipping = 'http://localhost:3046/api/shipping';
    this.portal.url.endPoint.quotas = 'http://localhost:3047/api/quotas';
    this.portal.url.endPoint.orders = 'http://localhost:3048/api/orders';
    this.portal.url.endPoint.store_liveshop =
      'http://localhost:3029/store/live';
    this.portal.url.endPoint.store_liveshop_guest =
      'http://localhost:3034/store/live-guest';
    this.portal.url.endPoint.store_liveshop_tags =
      'http://localhost:3035/store/live-tags';
    this.portal.url.endPoint.store_liveshop_order =
      'http://localhost:3036/store/live-order';
    this.portal.url.endPoint.store_liveshop_jobs =
      'http://localhost:3037/store/live-jobs';
    this.portal.url.endPoint.store_liveshop_participant =
      'http://localhost:3038/store/live-participant';
    this.portal.url.endPoint.store_cart = 'http://localhost:3030/store/cart';
    this.portal.url.endPoint.store_product =
      'http://localhost:3031/store/product';
    this.portal.url.endPoint.store_resources =
      'http://localhost:3032/store/resources';
    this.portal.url.endPoint.store_campaign_products =
      'http://localhost:3039/store/campaign-products';
    this.portal.url.endPoint.ws_store_liveshop = 'ws://localhost:4000';
    this.portal.url.endPoint.paymentNegotiation =
      'http://localhost:3033/payment-negotiation';
    this.portal.url.endPoint.custom_features =
      'http://localhost:3014/custom-features';
    this.portal.url.endPoint.lead_capture =
      'http://localhost:3041/api/lead-capture';
    this.portal.url.endPoint.documentation =
      'http://localhost:3050/api/documentation';
    this.portal.url.endPoint.workflow = 'http://localhost:3051/api/workflow';
    this.portal.url.endPoint.visual_merchandising =
      'http://localhost:3061/api/visual-merchandising';
    this.portal.url.endPoint.supplier_financial =
      'http://localhost:3062/api/supplier-financial';
    this.portal.url.endPoint.supplier_order =
      'http://localhost:3063/api/supplier-order';
    this.portal.url.endPoint.permission =
      'http://localhost:3055/api/permission';
    this.portal.url.endPoint.notifications =
      'http://localhost:3044/api/notifications';
    this.portal.url.endPoint.calendar = 'http://localhost:3045/api/calendar';
    this.portal.url.endPoint.help = 'http://localhost:3058/api/help';
    this.portal.url.endPoint.chatbot_integration =
      'http://localhost:3049/api/chatbot-integration';
    this.portal.url.endPoint.financial = 'http://localhost:3054/api/financial';
    this.portal.url.endPoint.customer_service =
      'http://localhost:3056/api/customer-service';
    this.portal.url.endPoint.ws_customer_service = 'ws://localhost:4001 ';
    this.portal.url.endPoint.dynamic_form =
      'http://localhost:3057/api/dynamic-form';
    this.portal.url.endPoint.invoice = 'http://localhost:3059/api/invoice';
    this.portal.url.endPoint.permission =
      'http://localhost:3055/api/permission';

    /* CONFIGURA O SCRIPT PARA LOCAL */
    this.portal.url.script = 'static/script/';

    /* CONFIGURA A COMPANY PARA BAIXAR UM OBJ DE COMPANY LOCAL */
    this.company.locationJson = `static/${this.domain}`;

    /* SETA A FLAG PARA SEU RESPECTIVO START */
    this.is = 'DEV';
    cb();
  }

  /*
    FUNÇÃO DE START PARA O SISTEMA EM PRODUÇÃO
  */
  initProduction(cb) {
    /* SETA A FLAG PARA SEU RESPECTIVO START */
    this.is = 'PROD';
    cb();
  }
}
